var app = angular.module("leonardo");

var IntegrationsStates = function ($stateProvider) {
  $stateProvider.state('integrations', {
    url: "/integrations",
    parent: 'authenticated.layout-main',
    title: 'Integrations',
    views: {
      'user': {
        templateUrl: 'views/templates/user/logged.html',
        controller: 'UserMenu'
      }
    },
    redirectTo: 'integrations.pms-sync',
    ncyBreadcrumb: {
      label: 'Integrations'
    }
  });

  $stateProvider.state('integrations.pms-sync', {
    url: "/pms-sync",
    title: 'PMS Sync',
    views: {
      'content@authenticated.layout-main': {
        templateUrl: 'views/templates/admin/integrations/pms-sync.html',
        controller: 'PmsSyncController'
      },
    },
    ncyBreadcrumb: {
      label: 'PMS Sync'
    }
  });
};

app.config(['$stateProvider', IntegrationsStates]);
